import { render, staticRenderFns } from "./About.vue?vue&type=template&id=1987d4f8&scoped=true"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
import style0 from "./About.vue?vue&type=style&index=0&id=1987d4f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1987d4f8",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Medias: require('/vercel/path0/components/elements/Medias/index.vue').default,Richtext: require('/vercel/path0/components/elements/Richtext.vue').default,Section: require('/vercel/path0/components/elements/Section.vue').default})
